const handleDeleteFrequencyFailFormParamFreq = {
  title: 'LA PERIODICIDAD NO PUEDE SER ELIMINADA'
};

export default handleDeleteFrequencyFailFormParamFreq;
